export interface IFrameInfo {
  i: number
  y: number
  x: number
  h?: number
  w?: number
  frame?: Phaser.Textures.Frame
  scale?: number
}

export interface IRawFrameInfo {
  i: number
  y: number
  x: number
  h: number
  w: number
  frame?: Phaser.Textures.Frame
  scale?: number
}

export function fi32(
  i: number,
  y: number,
  x: number,
  h: number = 1,
  w: number = 1,
): IFrameInfo {
  return {
    x,
    y,
    i,
    w,
    h,
  }
}

export function fAbi(
  i: number,
  y: number,
  h: number = 1,
  w: number = 1,
): IFrameInfo {
  return {
    x: y,
    y: 0,
    i,
    w,
    h,
  }
}

export function fiRaw(
  i: number,
  x: number,
  y: number,
  w: number,
  h: number,
): IRawFrameInfo {
  return {
    x,
    y,
    i,
    w,
    h,
  }
}

export function fiMonster(
  y: number,
  x: number,
  h: number = 1,
  w: number = 1,
): IFrameInfo {
  return {
    x,
    y,
    i: 2,
    w,
    h,
  }
}
